import React from "react";

const StepCard = ({ title, step, currentStep, completed, onEdit, children, wide }) => {
  const isActive = step === currentStep;
  const isDone = completed;
  const disabled = !isActive && !isDone;

  if (isDone && !isActive) {
    return (
      <div className={`card mb-3 consumer-step-card is-complete step-${step}`} style={{ borderColor: "#252525" }}>
        <div className="card-body py-2">
          <div className="d-flex justify-content-between align-items-center">
            <h5 className="fw-bold mb-0" style={{ fontSize: "15px", color: "#252525" }}>
              <span style={{ backgroundColor: "#252525", color: "#fce100", borderRadius: "50%", padding: "1px 4px", marginRight: "5px" }}>✓</span>
              {title}
            </h5>
            <button className="btn btn-sm" style={{ borderColor: "#252525", color: "#252525" }} onClick={onEdit}>Edit</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className={`card mb-3 consumer-step-card step-${step} ${isActive ? "is-active" : ""} ${disabled ? "is-disabled opacity-50" : ""}`}
      style={{ pointerEvents: disabled ? "none" : "auto" }}
    >
      <div className="card-body">
        <h5 className="fw-bold mb-3" style={{ fontSize: "16px" }}>{title}</h5>
        {children}
      </div>
    </div>
  );
};

export default StepCard;
